import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../_helpers/notification.service';
import { HelperService } from '../_helpers/helper.service';
import { ForgotPasswordService } from './forgot-password.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  user: any;
  result: any;

  constructor(private notification: NotificationService, 
    private helper: HelperService,
    private forgotPasswordService: ForgotPasswordService
  ) { }

  ngOnInit(): void {
  }
  forgotConfirm() {
    if(!this.helper.isValidEmail(this.user) && !this.helper.isValidUserName(this.user)) {
      return this.notification.showError('Please enter either your registered email address or user name.');
    }
    this.helper.showLoader(true);
    let data: any = {
      "user": this.user
    }
    this.forgotPasswordService.forgot({
      data: data,
      success: (response: any) => {
        this.helper.showLoader(false);
        if(response.message?.toLowerCase() == 'success') {
          this.notification.showInfo(
            'An email has been sent to your registered email address with password reset link. Please check your Inbox to proceed further.'
          );
        }
      },
      error: (error: any) => {
        this.helper.showLoader(false);
        this.notification.showError(error.errorMessage);
      }
    }); 
  }
}
